import { Toast } from "@newsela/angelou";
import { map } from "@s-libs/micro-dash";

import { subjectForSlug } from "@/subjects/subjects.constants";

export const GRADES = [
  "Kindergarten",
  "1st grade",
  "2nd grade",
  "3rd grade",
  "4th grade",
  "5th grade",
  "6th grade",
  "7th grade",
  "8th grade",
  "9th grade",
  "10th grade",
  "11th grade",
  "12th grade",
];

export const SUBJECTS = map(subjectForSlug, (name, id) => ({ id, name }));

export const EVENT_TOAST_SUCCESS_UPDATED = {
  showIcon: true,
  statusColor: Toast.statusColor.success,
  children: "Profile updated",
};

export const EVENT_TOAST_FAILED_UPDATED = {
  showIcon: true,
  statusColor: Toast.statusColor.danger,
  children: "Update failed",
};

export const getValidForm = ({ isValidGrades, subjects }) => {
  return isValidGrades && subjects.length >= 1;
};

export const getHasFormChanged = (initialForms, forms) => {
  return initialForms.some((initialForm, i) => initialForm !== forms[i]);
};
